import { Injectable, inject } from "@angular/core";
import { HelpersService } from "../helpers-service/helpers.service";

@Injectable({
    providedIn: "root",
})
export class UserSettingsIframeHeightService {
    private helpersService = inject(HelpersService);

    constructor() {}

    init(elementToWatch: HTMLElement): void {
        const resizeObserver = new ResizeObserver(([el]) => {
            this.onResize((el.target as HTMLBodyElement).offsetHeight);
        });

        resizeObserver.observe(elementToWatch);
    }

    onResize(height: number): void {
        this.helpersService.sendSetFrameHeight(height);
    }
}
